export class StringUtil {
  public static trimString(value: string | undefined): string {
    return value?.trim() ?? '';
  }
}
